export default "__VITE_ASSET__DOWNtbQV__"